var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.193 9.664c0-3.467-2.4-6.664-8.796-6.664H3.335C2.603 3 2 3.592 2 4.335V28.33c0 .732.592 1.335 1.335 1.335h17.332c6.663 0 9.333-3.52 9.333-7.202 0-3.681-3.52-6.394-7.202-6.394 3.671-.012 6.395-2.94 6.395-6.406zm-15.997 9.333h7.998a2.39 2.39 0 0 1 2.4 2.4 2.39 2.39 0 0 1-2.4 2.401h-12.8V8.868h11.993c1.335 0 2.4.796 2.4 2.13 0 1.335-1.065 2.132-2.4 2.132h-7.191c-.732 0-1.335.592-1.335 1.335v3.197c0 .732.604 1.335 1.336 1.335z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrd);
export default __webpack_public_path__ + "static/media/BRD.b7b185c857c11f4984bda3918820d215.svg";
export { ForwardRef as ReactComponent };